import { isDev } from '@common'

import { configureStore } from '@reduxjs/toolkit'
import userReducer from './slices/userSlice'
import cartReducer from './slices/cartSlice'
import dashboardReducer from './slices/dashboardSlice'
import orderReducer from './slices/orderSlice'
import pubsubReducer from './slices/pubsubSlice'
import membershipReducer from './slices/membershipSlice'

const store = configureStore({
    reducer: {
        user: userReducer,
        cart: cartReducer,
        dashboard: dashboardReducer,
        order: orderReducer,
        pubsub: pubsubReducer,
        membership: membershipReducer,
    },
    devTools: isDev,
    middleware: getDefault =>
        getDefault({
            // Enable middleware checks in dev, disable in production for performance
            serializableCheck: isDev,
            immutableCheck: isDev,
        }),
})

export default store
